<template>
  <el-dialog :title="title" v-model="show" size="full">
    <div v-loading="loading" :element-loading-text="type === 0 ? '修改保存中。。。' : '新增保存中。。。'">
      <div>
        <el-button @click='addHint'>新增解题提示</el-button>
      </div>
      <hint-table :tableData="hintList" ></hint-table>
    </div>
  </el-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import hintTable from '@/components/hintTable/hintTable'
  import hintDlg from '@/components/hintDlg'

  export default {
    data () {
      return {
        show: false,
        loading: false,
        tempstr: '',
        guid: '',
        tmguid: '',
        id: -1
      }
    },
    computed: {
      ...mapGetters([
        'hintList'
      ]),
      title () {
        return `解题提示列表`
      }
    },
    created () {
      // console.log('-----00000000000---------this.tmguid=' + this.tmguid)
      // this.$store.dispatch('actions_getSolutionList', this.tmguid)
    },
    components: {
      hintTable,
      hintDlg
    },
    watch: {
      show: function (val) {
        if (val) {
          this.$store.dispatch('actions_getHintList', this.tmguid)
        }
      }
    },
    methods: {
      addHint () {
        hintDlg({
          isEditData: false,
          tmguid: this.tmguid
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// main.vue?7107b9dc